/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ phrase: NonNullable<unknown>, metric: NonNullable<unknown> }} Perks_Trigger_RankedInputs */



/**
* | output |
* | --- |
* | "{phrase} by {metric}" |
*
* @param {Perks_Trigger_RankedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_ranked = /** @type {((inputs: Perks_Trigger_RankedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_RankedInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.phrase} по числу ${i?.metric}`)
	return /** @type {LocalizedString} */ (`${i?.phrase} by ${i?.metric}`)
});